module.exports = __webpack_public_path__ + "img/kiwoom_visual_m.ba712d12.png";